import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'customDate',
})
export class DatePipe implements PipeTransform {

  transform(value: any, timezone: string = 'Asia/Kolkata'): string {
    const date = moment.utc(value).tz(timezone);  // ✅ FIXED

    if (date.isSame(moment.tz(timezone), 'day')) {
      // Today
      return date.format('h:mm A');
    } else if (date.isSame(moment.tz(timezone).subtract(1, 'day'), 'day')) {
      // Yesterday
      return `Yesterday, ${date.format('h:mm A')}`;
    } else if (date.isSame(moment.tz(timezone), 'week')) {
      // This week
      return date.format('dddd, h:mm A');
    } else {
      // Older
      return date.format('MMM D YYYY, h:mm A');
    }
  }
}
